import React, { useEffect } from 'react';
import './Aquaa.css';
import { useDispatch, useSelector } from 'react-redux';
import { getRoleBasedView } from '../../actions/Administration/admin.action';
import AdminBreadcrumb from '../../components/Administration/General/Admin-breadcrumb';
import { useHistory } from 'react-router-dom';

const AquaaApplications = () => {
    const dispatch = useDispatch();
    const history = useHistory();
      const RoleBasedView = useSelector((state) => state.adminAccountReducer.RoleBasedView);
        useEffect(() => {
            dispatch(getRoleBasedView())
        }, [dispatch])


    const SubApps = [
        {
            id: 1,
            href: "/aquaa",
            name: 'AQuAA ASD ',
            enable: true,
            visible: RoleBasedView?.[0]?.['AQuAA']?.[0]?.ReadWrite,
            description:'With ContactID'
        },
        {
            id: 2,
            href: "/aquaanonasd",
            name: 'AQuAA Non-ASD',
            enable: true,
            visible: RoleBasedView?.[0]?.['AQuAA']?.[0]?.ReadWrite,
            description:'Without ContactID'
        },
       {
            id: 3,
            href: "/aquaaadminevaluationsdelete",
            name: 'AQuAA Data',
            enable: true,
            visible: RoleBasedView?.[0]?.['AQuAA']?.[0]?.ReadWrite,
        },
         {
            id: 4,
            href: "/aquaaadminonboardlanding",
            name: 'AQuAA ADMIN',
            enable: true,
            visible: RoleBasedView?.[0]?.['AQuAA OnBoard']?.[0]?.ReadWrite
        },
        {
            id: 5,
            href: "/icedupdate",
            name: 'AQuAA ICED',
            enable: true,
            visible: RoleBasedView?.[0]?.['AQuAA']?.[0]?.ReadWrite,
        },
        {
            id: 6,
            href: "/aquaaagentsevaluations",
            name:'AQuAA',
            description: 'Agent Evaluations',
            enable: true,
            visible: RoleBasedView?.[0]?.['AQuAA Agent']?.[0]?.Read
        },
        {
            id: 6,
            href: "/recommendations",
            name:'Recommendations',
            description: '',
            enable: true,
            visible: RoleBasedView?.[0]?.['AQuAATraining ReadWrite']?.[0]?.ReadWrite    
        },
        {
            id: 7,
            href: "/vishing",
            name:'Vishing Tracker',
            description: '',
            enable: true,
            visible: RoleBasedView?.[0]?.['AQuAA']?.[0]?.ReadWrite,    
        }
    ]
  return (
    <div>
    <AdminBreadcrumb value1={() => history.push('/applications')} label1='Applications' isActive2={false}  label2='AQuAA'/>
   <div style={{display:'flex',flexWrap:'wrap'}}> {SubApps.map((app, index) => (
        (app.enable && app.visible === 1) ? (
            <div key={index} >
            <div className='App_cards' key={app.id} onClick={() => history.push(app.href)}>
        {app.img ? (
          <img src={app.img} alt='' height='200px' width='200px' />
        ) : (
          <div style={{ height: '200px', width: '200px', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '24px', fontWeight: 'bold', border: '1px solid #ccc',color:'#004aac' }}>
            {app.name}
          </div>
        )}
        <div style={{display: 'flex', justifyContent: 'center',color:'#004aac'}}>{app.description}</div>
      </div>
            </div>
        ) : (
            app.visible === 1 && (
                <div key={index} className='aquaaApps_list_disabled'>
                    {app.name}
                </div>
            )
        )
    ))}</div>
</div>

  )
}

export default AquaaApplications